<div class="message-details-page jhm-page" [class.mobile]="isMobile">
	@if (isMobile) {
		<div class="jhm-top-toolbar">
			<div class="left">
			  <div class="back">
				<button (click)="goToPreviousPage()">
				  <img src="./assets/images/arrow-left.svg">
				</button>
			  </div>
			</div>
			<div class="right">
				<button class="jhm-icon-button transparent" (click)="addPhotosClicked()"><i class="fa-light fa-paperclip"></i></button>
				<button class="jhm-icon-button transparent" (click)="deleteClicked()"><i class="fa-light fa-trash"></i></button>
				<button [class.disabled]="!canSendMessage(false)" class="jhm-icon-button transparent send" (click)="sendClicked(true)"><i class="fa-solid fa-paper-plane-top"></i></button>
			</div>
		  </div>
	}
	@else {
		<div class="jhm-top-toolbar">
		  <div class="left">
			<div class="back">
			  <button (click)="goToPreviousPage()">
				<img src="./assets/images/arrow-left.svg">
			  </button>
			</div>
			<div class="navigation-item" [class.focus]="selectedPage ==='MESSAGE'">
			  <button>New Message</button>
			</div>
		  </div>
		</div>
	}
  @if (messageDraft) {
    <div class="content-wrapper message">
      <div class="message-input">
        @if (showInvalidEmailError) {
          <div class="warning-message">You can only add a new contact if there is a valid email address specified</div>
        }
        <jhm-select-contact-search [selectedContactId]="messageDraft?.recipientId" (contactChange)="contactChanged($event)"></jhm-select-contact-search>
        <div class="subject-input-wrapper">
          <mat-form-field appearance="fill">
            <input matInput [(ngModel)]="messageDraft.subject" placeholder="Subject" />
          </mat-form-field>
        </div>
        <div class="message-content">

          <!-- <mat-form-field>
            <mat-label>Autosize textarea</mat-label>
            <textarea matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="1"
                      cdkAutosizeMaxRows="5"
                      [(ngModel)]="messageDraft.text" placeholder="Message goes here..."></textarea>
          </mat-form-field> -->

          <textarea matInput
            [(ngModel)]="messageDraft.text" placeholder="Message goes here...">
          </textarea>


        </div>
        @if (messageDraft.senderUserType === 'CIVILIAN') {
          <div class="photos-label">
            {{photoCount}} Photo(s)
          </div>
          <div class="upload-previews">
            @for (photo of messageDraft.photos; track photo) {
              <jhm-photo-preview
                [photoPreviewUrl]="photo.url"
                [filename]="photo.filename"
                (deleteClicked)="deletePhoto(photo)">
              </jhm-photo-preview>
            }
          </div>
        }
      </div>
	  @if (!isMobile) {
		<div class="message-actions">
		  <div class="action-buttons">
			<div class="left-buttons">
			  @if (canAddPhotos) {
				<button data-pw="add-photos-btn" class="jhm-button" (click)="addPhotosClicked()" [class.disabled]="messageDraft.photos.length > 10">
				  <img src="./assets/images/paperclip-black.svg">
				Add Photos{{messageDraft.photos.length > 10 ? ' (Max 10)' : ""}}</button>
			  }
			</div>
			<div class="right-buttons">
			  <button class="jhm-button white credit-indicator" (click)="creditsClicked()">
				<i class="fa-light fa-envelope-open-dollar"></i>{{formatCost(messageCost.totalMessageCost)}}
			  <!-- Popover -->
			  @if (showCreditsInfo) {
				<div class="credits-popover">
				  <div class="credit-info-row">
					<div class="left"></div>
					<div class="middle"><img src="./assets/images/comment.svg"></div>
					<div class="right">
					  <div class="title">Message</div>
					  <div class="value">{{formatCost(messageCost.costPerMessage)}}</div>
					  <!-- <span>(you have {{availableCredits}} credit<span *ngIf="availableCredits !== 1">s</span> available)</span> -->
					</div>
				  </div>
				  <div class="credit-info-row">
            <!-- <div *ngIf="canAddPhotos" class="credit-info-row"> -->
            <div class="left"><img src="./assets/images/plus-grey.svg"></div>
            <div class="middle" [class.disabled]="photoCount < 1">
              @if (photoCount >= 1) {
              <img src="./assets/images/paperclip-blue.svg">
              }
              @if (photoCount < 1) {
              <img src="./assets/images/paperclip-grey.svg">
              }
            </div>
            <div class="right">
              <div class="title">Photos ({{(photoCount > messageCost.discountPhotosAfterX) ? messageCost.discountPhotosAfterX : photoCount}})</div>
              <div class="value">{{formatCost(((photoCount > messageCost.discountPhotosAfterX) ? messageCost.discountPhotosAfterX : photoCount) * messageCost.costPerPhoto)}}</div>
            </div>
          </div>
          @if ((photoCount - messageCost.discountPhotosAfterX) >= 0) {
          <div class="credit-info-row">
            <div class="left"><img src="./assets/images/plus-grey.svg"></div>
            <div class="middle" [class.disabled]="photoCount < 1">
              @if (photoCount >= 1) {
              <img src="./assets/images/paperclip-blue.svg">
              }
              @if (photoCount < 1) {
              <img src="./assets/images/paperclip-grey.svg">
              }
            </div>
            <div class="right">
              <div class="title">Discounted Photos ({{photoCount - messageCost.discountPhotosAfterX}})</div>
              <div class="value">{{formatCost((photoCount - messageCost.discountPhotosAfterX) * messageCost.costPerDiscountedPhoto)}}</div>
            </div>
				  </div>
          }
				  <div class="horizontal-line"></div>
				  <div class="credit-info-row">
					<div class="left"><img src="./assets/images/equals-grey.svg">
					</div>
					<div class="middle"><img src="./assets/images/credit-blue-wireframe.svg"></div>
					<div class="right">
					  <div class="title">Total</div>
					  <div class="value">{{formatCost(messageCost.totalMessageCost)}}</div>
					</div>
				  </div>
				</div>
			  }
			  <!-- End Popover -->
			</button>
			<div class="vertical-line"></div>
			@if (isInmate) {
			  <button class="jhm-button white" [class.disabled]="!canSendMessage(true)" (click)="sendClicked(true)">
				<i class="fa-light fa-paper-plane-top"></i>Bill the Receiver
			  </button>
			}
			<button class="jhm-button primary" [class.disabled]="!canSendMessage(false)" (click)="sendClicked(false)">
			  @if (canSendMessage(false)) {
				<i class="fa-solid fa-paper-plane-top"></i>
				}@if (!canSendMessage(false)) {
				<i class="fa-light fa-paper-plane-top"></i>
				}Send
				<!-- <img *ngIf="!canSendMessage(false)" src="./assets/images/paper-plane-top-grey-filled.svg">Send for {{creditCount}} Credit<span *ngIf="creditCount !== 1">s</span> -->
			  </button>
			</div>
		  </div>
		</div>
	  }
    </div>
  }
</div>
@if (showPhotosModal) {
  <div class="jhm-modal-background">
    <div id="draft-photos-modal" class="jhm-modal draft-photos-modal">
      <header>
        <h2>Attach Photos</h2>
        <button class="jhm-button" (click)="showPhotosModal = false">
          <img src="./assets/images/black-x.svg">
        </button>
      </header>
      <div>
        <div class="photo-upload">
          <div class="button-and-text">
            @if (uploadingPhoto) {
              <span>Uploading image now. Depending on how large the photo is and your internet
              connection, it may take a while. If it takes longer than a few minutes, try again later.</span>
            }
            @if (uploadError?.permittedSize > 0) {
              <span class="warning-message">
                The photo you uploaded is {{formatBytesToMB(uploadError.actualSize)}} MB. The maximum
                size allowed is {{formatBytesToMB(uploadError?.permittedSize)}} MB
              </span>
            }
            @if (uploadError && uploadError?.permittedSize <= 0) {
              <span class="warning-message">
                Their was an error while upload your photo, please try again later. If the problem
                persists, please contact support.
              </span>
            }
            <label for="file-upload" class="custom-file-upload">
              <i class="fa fa-cloud-upload"></i>Upload
            </label>
            <input id="file-upload" type="file" multiple
              (change)="fileSelected($event)" accept=".jpg,.jpeg,.png">
            <div>
              We recommend a 360x360px PNG or JPG.
            </div>
          </div>
        </div>
      </div>
      <footer class="filled">
        <button class="jhm-button" (click)="showPhotosModal = false; uploadError = null">Cancel</button>
        <!-- <button class="jhm-button primary" (click)="deleteMessage()">Delete</button> -->
      </footer>
    </div>
  </div>
}
@if (loading) {
  <jhm-loading></jhm-loading>
}
@if (showAddContactModal) {
    <jhm-add-contact (exit)="createContactExit($event)"></jhm-add-contact>
	<!-- <jhm-create-contact (exit)="createContactExit($event)"></jhm-create-contact> -->
}